import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { toast } from "@krea/shared/design-system/utils/toast";

import { mutationKeyMap } from "@/features/query-client";

import { reopenApplication } from "../../api";
import { useOptimisticallyUpdateLenderApplication } from "../use-optimistically-update-lender-application";

type IMutationResult = Awaited<ReturnType<typeof reopenApplication>>;

interface IReopenLenderApplicationMutationParams {
  lenderCompanyId: number;
  lenderApplicationId: number;
}

export const useReopenLenderApplicationMutation = () => {
  const optimisticallyUpdateLenderApplication =
    useOptimisticallyUpdateLenderApplication();

  return useMutation<
    IMutationResult,
    AxiosError,
    IReopenLenderApplicationMutationParams
  >({
    mutationFn: ({ lenderCompanyId, lenderApplicationId }) =>
      reopenApplication(lenderCompanyId, lenderApplicationId),
    mutationKey: mutationKeyMap.reopenApplication,
    onSuccess: (response, { lenderApplicationId }) => {
      optimisticallyUpdateLenderApplication(lenderApplicationId, response);
    },
    onError: (_error, { lenderApplicationId }) => {
      toast.error(`Failed to reopen application ${lenderApplicationId}`);
    },
  });
};
